import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Send02 = function Send02(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12.0005 18.9998v-7m.2915 7.0847 6.9784 2.3362c.5469.1831.8204.2746.989.2089a.5.5 0 0 0 .3-.3309c.0488-.1743-.0691-.4374-.3049-.9638L12.766 3.6222c-.2306-.5147-.3459-.772-.5066-.8518a.5.5 0 0 0-.4432-.0007c-.1609.0792-.277.3362-.5093.8502l-7.5545 16.716c-.2377.526-.3565.7889-.3082.9634a.5.5 0 0 0 .299.3319c.1686.0662.4425-.0248.9903-.2066l7.0525-2.3408c.0939-.0311.1408-.0467.1889-.0529a.5.5 0 0 1 .1283.0002c.048.0063.0949.022.1888.0534"
    })
  }));
};
export default Send02;